import request from 'utils/request'

/**
 * 查询信用风险等级评估详情
 * @param {*} data
 */
export const getRiskEvaluate = data => {
  return request().post('bp/risk/evaluate/query', data)
}

/**
 * 计算得分
 * @param {*} data
 */
export const calcEvaluate = data => {
  return request().post('bp/risk/evaluate', data)
}
